import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #FFFAF5;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h2`
  color: #FF7C24;
  font-size: 20px;
  margin-bottom: 1rem;
`;

const Stat = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #232830;
  margin-bottom: 1rem;
`;

const SourceList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SourceItem = styled.li`
  font-size: 16px;
  margin-bottom: 0.5rem;
  color: #232830;
`;

export default function ReferralCard({ referralData = [] }) {
  const totalReferrals = referralData.length;

  const sourceBreakdown = referralData.reduce((acc, r) => {
    const source = r.referralSource || 'unknown';
    acc[source] = (acc[source] || 0) + 1;
    return acc;
  }, {});

  return (
    <Card>
      <Title>Referrals</Title>
      <Stat>{totalReferrals} Total Referrals</Stat>
      <SourceList>
        {Object.entries(sourceBreakdown).map(([source, count]) => (
          <SourceItem key={source}>
            {source}: {count}
          </SourceItem>
        ))}
      </SourceList>
    </Card>
  );
}
